import { useState } from 'react';
import { TimesheetTable } from '../components/TimesheetTable';

function getMonthRange(year: number, month: number) {
  const pad = (n: number) => String(n).padStart(2, '0');
  const startDate = `${year}-${pad(month + 1)}-01`;
  const lastDay = new Date(year, month + 1, 0).getDate();
  const endDate = `${year}-${pad(month + 1)}-${lastDay}`;
  const monthLabel = new Date(year, month, 1).toLocaleDateString('pt-BR', {
    month: 'long',
    year: 'numeric',
  });
  return { startDate, endDate, monthLabel };
}

export default function TimesheetPage() {
  const now = new Date();
  const [year, setYear] = useState(now.getFullYear());
  const [month, setMonth] = useState(now.getMonth());

  const { startDate, endDate, monthLabel } = getMonthRange(year, month);

  const handlePrev = () => {
    if (month === 0) {
      setMonth(11);
      setYear((y) => y - 1);
    } else {
      setMonth((m) => m - 1);
    }
  };

  const handleNext = () => {
    if (month === 11) {
      setMonth(0);
      setYear((y) => y + 1);
    } else {
      setMonth((m) => m + 1);
    }
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-foreground">Folha de Ponto</h1>
        <p className="text-muted-foreground mt-1">Visualize seu histórico de horas e banco de horas</p>
      </div>

      <TimesheetTable
        startDate={startDate}
        endDate={endDate}
        monthLabel={monthLabel}
        onPrevMonth={handlePrev}
        onNextMonth={handleNext}
      />
    </div>
  );
}
